import ApiRouteProvider from '../route'
import axios from '@axios'
import Cache from "@core/api/request/Cache";

export default {
    lists() {
        return Cache.item('SubstanceLists', () => {
            return axios.get(ApiRouteProvider.substances.lists());
        }).getPromise();
    },

    listSubstances(listId) {
        return Cache.item('SubstanceListSubstances' + listId, () => {
            return axios.get(ApiRouteProvider.substances.listSubstances(listId));
        }).getPromise();
    },

    materialCategories() {
        return Cache.item('SubstanceMaterialCategories', () => {
            return axios.get(ApiRouteProvider.substances.materialCategories());
        }).getPromise();
    },

    search(qs) {
        return axios.get(ApiRouteProvider.substances.search(qs));
    },

    getCard(id) {
        return axios.get(ApiRouteProvider.getBaseUrl() + '/substance/card/' + id);
    },

    saveCard(id, card) {
        return axios.put(ApiRouteProvider.getBaseUrl() + '/substance/card/' + id, card);
    },

    addUserSubstance(substance) {
        return axios.post(ApiRouteProvider.getBaseUrl() + '/substance/user-substance', {
            substance,
        });
    },

    linkSubstance(listId, substanceId, parentId) {
        return axios.post(ApiRouteProvider.getBaseUrl() + '/substance/list/' + listId + '/substances/link', {
            substance: substanceId,
            parent: parentId,
        })
    }
};
